import React from 'react'
import yn from 'yn'
import tourIcon from '../../../../assets/icons/virtual-tour-dark.svg'
import floorPlanIcon from '../../../../assets/icons/floor-plan-dark.svg'

const BkFlowRoomCardMediaGalleryFeatureToggles = props => {
	const {
		cards,
		hotelLabels,
		onViewFloorPlan,
		virtualTourEvent,
	} = props

	let roomVirtualTourSrc = null,
			roomFloorPlanSrc = null,
			roomMapUrlSrc = null

	if (
		cards &&
		cards.viewExtensions
	) {
		if (cards.viewExtensions.roomVirtualTourSrc) {
			roomVirtualTourSrc = cards.viewExtensions.roomVirtualTourSrc
		}

		if (cards.viewExtensions.mapLink) {
			roomMapUrlSrc = cards.viewExtensions.mapLink
		}

		if (
			cards.viewExtensions.roomFloorPlanSrc &&
			cards.viewExtensions.roomFloorPlanSrc.path
		) {
			roomFloorPlanSrc = cards.viewExtensions.roomFloorPlanSrc.path
		}
	}

	return (
		<div className="bk-flow-room__card-media-feature-toggles">
			{ yn(process.env.REACT_APP_COMPONENT_ROOM_IMAGE_FEATURE_TOGGLES) &&
				roomVirtualTourSrc &&
				<button
					className="bk-flow-room__card-media-feature-toggle virtual-tour btn btn-alt center-xs middle-xs"
					onClick={ virtualTourEvent }
					aria-label="Open Virtual Tour"
				>
					<img src={ tourIcon } alt="Virtual Tour" />
					<span className="u-mobile-hide-tablet-flex">{ hotelLabels.virtualTour ? hotelLabels.virtualTour : '360 Tour' }</span>
				</button>
			}

			{ yn(process.env.REACT_APP_COMPONENT_ROOM_IMAGE_FEATURE_TOGGLES) &&
				roomFloorPlanSrc &&
				<button
					className="bk-flow-room__card-media-feature-toggle floor-plan btn btn-alt center-xs middle-xs"
					onClick={
						onViewFloorPlan
							? onViewFloorPlan
							: () => window.open(roomFloorPlanSrc, 'Floor plan', 'height=600,width=450')
					}
					aria-label="Open Floor Plan"
				>
					<img src={ floorPlanIcon } alt="Floor Plan" />
					<span className="u-mobile-hide-tablet-flex">{ hotelLabels.floorPlan ? hotelLabels.floorPlan : 'Floor Plan' }</span>
				</button>
			}

			{ yn(process.env.REACT_APP_COMPONENT_ROOM_IMAGE_FEATURE_TOGGLES) &&
				roomMapUrlSrc &&
				<button
					className="bk-flow-room__card-media-feature-toggle map-link btn btn-alt row center-xs middle-xs"
					onClick={ () => window.open(roomMapUrlSrc, 'Map URL') }
					aria-label="Open Map"
				>
					<img src={ floorPlanIcon } alt="Map Link" />
					<span className="u-mobile-hide-tablet-flex">{ hotelLabels.map ? hotelLabels.map : 'Map' }</span>
				</button>
			}
		</div>
	)
}


export default BkFlowRoomCardMediaGalleryFeatureToggles


// WEBPACK FOOTER //
// ./src/components/room/elements/gallery/BkFlowRoomCardMediaGalleryFeatureToggles.js